import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCIm9KBqG4EPRP-C3xB1J2M0pd6wLAbaCM',
  authDomain: 'anette-f980e.firebaseapp.com',
  projectId: 'anette-f980e',
  storageBucket: 'anette-f980e.firebasestorage.app',
  messagingSenderId: '698656196454',
  appId: '1:698656196454:web:1714d57d5f85238cca2aa7',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
